module.exports = __webpack_public_path__ + "img/cpe_icons_start.1a5e5b58.svg";